import { render } from "./CSkatHeader.vue?vue&type=template&id=280ef63e&scoped=true"
const script = {}

import "./CSkatHeader.vue?vue&type=style&index=0&id=280ef63e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280ef63e"]])

export default __exports__